import React, { FC, memo } from 'react';
import { DepositsTable } from './DepositsTable';
import { TableFilterContextProvider } from 'features/TableFilter';

export const DepositsPage: FC = memo(() => {
  return (
    <TableFilterContextProvider>
      <DepositsTable />
    </TableFilterContextProvider>
  );
});
